// API配置文件
// 🎯 Security: Supports local development and production via Nginx reverse proxy

// 检测当前访问方式
const getApiBaseUrl = (): string => {
  // 🎯 优先使用环境变量配置（支持手动指定）
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }
  
  const hostname = window.location.hostname;
  const port = window.location.port;
  
  // 🎯 本地开发：直接访问后端（127.0.0.1:3001）
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://127.0.0.1:3001';
  }
  
  // 🎯 生产环境：通过 Nginx 访问（端口 80/443）
  // 使用相对路径，Nginx 会代理 /api/ 到后端
  if (port === '' || port === '80' || port === '443') {
    return ''; // 使用相对路径，Nginx 会代理到 /api/
  }
  
  // 🎯 直接访问前端端口（3000）时，使用相对路径或回退到本地后端
  // 这种情况通常发生在开发环境或测试环境
  if (port === '3000') {
    return 'http://127.0.0.1:3001';
  }
  
  // 🎯 其他情况：使用相对路径（假设有 Nginx 代理）
  return '';
};

export const API_BASE_URL = getApiBaseUrl();

// API端点配置
export const API_ENDPOINTS = {
  API_BASE: API_BASE_URL,
  HEALTH: `${API_BASE_URL}/api/health`,
  DEVICES: `${API_BASE_URL}/api/devices`,
  APK_VERSIONS: `${API_BASE_URL}/api/apk-versions`,
  TESTS: `${API_BASE_URL}/api/tests`,
  TESTS_NEW: `${API_BASE_URL}/api/tests-new`,
  ACCOUNTS: `${API_BASE_URL}/api/tests-new/integrations`,
  ACCOUNTS_BULK: `${API_BASE_URL}/api/tests-new/integrations/bulk-upsert-accounts`,
  ACCOUNTS_ALL: `${API_BASE_URL}/api/tests-new/integrations/all-accounts`,
  DASHBOARD: `${API_BASE_URL}/api/dashboard`,
  STATISTICS: `${API_BASE_URL}/api/statistics`,
  SCREEN_MONITOR: `${API_BASE_URL}/api/screen-monitor`,
  USERS: `${API_BASE_URL}/api/users`,
};

// API配置完成
